import { organisationConstants } from '../../_constants/organisation.constants';
import { organisationService } from '../../_services/organisation.service';

export const UploadAssessmentAction = {
    UploadAssessmentActionApi,
    UploadRespondentActionApi,
    UploadAssessmentResponsesActionApi,
    UploadAssessmentResponsesResultListActionApi,
    UploadAssessmentResponsesResultViewActionApi
}

function UploadAssessmentActionApi(data, sellerOrgData, instrument_action, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.UploadAssessmentActionService(data)
            .then(
                uploaded_assessment => {
                    dispatch(success(uploaded_assessment));
                    dispatch(instrument_action(sellerOrgData));
                    if(callback) {
                        callback(uploaded_assessment)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(null)
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPLOAD_ASSESSMENT_API} }
    function success(uploaded_assessment) { return { type: organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_API, uploaded_assessment: uploaded_assessment } }
    function failure(error) { return { type: organisationConstants.ERROR_UPLOAD_ASSESSMENT_API, error } }
}

function UploadRespondentActionApi(data, sellerOrgData, instrument_action, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.UploadRespondentActionService(data)
            .then(
                uploaded_respondent => {
                    dispatch(success(uploaded_respondent));
                    dispatch(instrument_action(sellerOrgData));     
                    if(callback) {
                        callback(uploaded_respondent)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(null)
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPLOAD_RESPONDENT_API} }
    function success(uploaded_respondent) { return { type: organisationConstants.RECIEVE_UPLOAD_RESPONDENT_API, uploaded_respondent: uploaded_respondent } }
    function failure(error) { return { type: organisationConstants.ERROR_UPLOAD_RESPONDENT_API, error } }
}

function UploadAssessmentResponsesActionApi(data, sellerOrgData, instrument_action, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.UploadAssessmentResponsesActionService(data)
            .then(
                uploaded_assessment_responses => {
                    dispatch(success(uploaded_assessment_responses));
                    dispatch(instrument_action(sellerOrgData));
                    if(callback) {
                        callback(uploaded_assessment_responses)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(null)
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPLOAD_ASSESSMENT_RESPONSES_API} }
    function success(uploaded_assessment_responses) { return { type: organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_API, uploaded_assessment_responses: uploaded_assessment_responses } }
    function failure(error) { return { type: organisationConstants.ERROR_UPLOAD_ASSESSMENT_RESPONSES_API, error } }
}

function UploadAssessmentResponsesResultListActionApi(orgId, instrumentId, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.UploadAssessmentResponsesResultListActionService(orgId, instrumentId)
            .then(
                uploaded_assessment_responses_result_list => {
                    dispatch(success( uploaded_assessment_responses_result_list));
                    if(callback) {
                        callback(uploaded_assessment_responses_result_list)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(null)
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API} }
    function success(uploaded_assessment_responses_result_list) { return { type: organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API, uploaded_assessment_responses_result_list: uploaded_assessment_responses_result_list } }
    function failure(error) { return { type: organisationConstants.ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_LIST_API, error } }
}

function UploadAssessmentResponsesResultViewActionApi(data, orgId, instrumentId, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.UploadAssessmentResponsesResultViewActionService(data, orgId, instrumentId)
            .then(
                uploaded_assessment_responses_result_view => {
                    dispatch(success( uploaded_assessment_responses_result_view));
                    if(callback) {
                        callback(uploaded_assessment_responses_result_view)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if(callback) {
                        callback(null)
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API} }
    function success(uploaded_assessment_responses_result_view) { return { type: organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API, uploaded_assessment_responses_result_view: uploaded_assessment_responses_result_view } }
    function failure(error) { return { type: organisationConstants.ERROR_UPLOAD_ASSESSMENT_RESPONSES_RESULT_VIEW_API, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/organisations/UploadAssessmentAction.action.js